import axios from "axios";
/* eslint-disable */

const types = {
  SET_IMAGE_MODAL: "SET_IMAGE_MODAL",
  SET_OPEN_MODAL: "SET_OPEN_MODAL",
  SET_SLIDERS: "SET_SLIDERS",
  SET_OFFER: "SET_OFFER",
  SET_PRICE: "SET_PRICE",
  SET_DATE_INIT: "SET_DATE_INIT",
  SET_PRICE_DIP: "SET_PRICE_DIP",
};

const state = {
  openPopup: false,
  imagen: "",
  sliders: [],
  offer: [],
  price: 1530,
  date_init: "",
  price_dip: 0,
};

const actions = {
  setModalImagen({ commit, dispatch }, data) {
    commit(types.SET_OPEN_MODAL, data);
  },
  setImagenPopup({ commit, dispatch }, data) {
    commit(types.SET_IMAGE_MODAL, data);
  },
  setSliders({ commit, dispatch }, data) {
    commit(types.SET_SLIDERS, data);
  },
  setOffer({ commit, dispatch }, data) {
    commit(types.SET_OFFER, data);
  },
  getFeedData({ commit, dispatch }) {
    axios({
      method: "get",
      url: "https://www.admin-uva.tidingo.com/api/data-uvaenlinea",
      config: {
        headers: {
          "Access-Control-Allow-Origin": "*",
          "Content-Type": "application/json",
        },
        withCredentials: true,
        credentials: "same-origin",
      },
    })
      .then(function(response) {
        var data = response.data.data;
        var the_image = null;
        if (data.popups != null) {
          var image = data.popups.image;
          if (image.indexOf("https") < 0) {
            the_image = "https://www.admin-uva.tidingo.com/" + image;
          } else {
            the_image = image;
          }
          dispatch("setImagenPopup", the_image);
          dispatch("setModalImagen", true);
        }
        dispatch("setSliders", data.sliders);
        dispatch("setOffer", data.offer);
        var campus_selected = data.campus_selected;
        commit(types.SET_PRICE, campus_selected.price);
        commit(types.SET_PRICE_DIP, campus_selected.price_dip);
        commit(types.SET_DATE_INIT, '16 de Jun');
        var social_media_facebook = document.getElementById(
          "social_media_facebook"
        );
        social_media_facebook.setAttribute("href", campus_selected.facebook);
        if (campus_selected.whatsapp != null) {
          var social_media_whatsapp = document.getElementById(
            "social_media_whatsapp"
          );
          social_media_whatsapp.setAttribute(
            "href",
            "https://wa.me/" +
              campus_selected.whatsapp +
              "/?text=Hola%20Uvaenlinea"
          );
          var social_media_whatsapp_movil = document.getElementById(
            "social_media_whatsapp_movil"
          );
          social_media_whatsapp_movil.setAttribute(
            "href",
            "https://wa.me/" +
              campus_selected.whatsapp +
              "/?text=Hola%20Uvaenlinea"
          );
          document.getElementById("social_media_whatsapp").style.display =
            "inline-flex";
        } else {
          document.getElementById("social_media_whatsapp").style.display =
            "none";
        }
        var social_media_facebook_movil = document.getElementById(
          "social_media_facebook_movil"
        );
        social_media_facebook_movil.setAttribute(
          "href",
          campus_selected.facebook
        );
      })
      .catch(function() {});
  },
};

const mutations = {
  [types.SET_IMAGE_MODAL](state, data) {
    state.imagen = data;
  },
  [types.SET_OPEN_MODAL](state, data) {
    state.openPopup = data;
  },
  [types.SET_SLIDERS](state, data) {
    state.sliders = data;
  },
  [types.SET_OFFER](state, data) {
    state.offer = data;
  },
  [types.SET_PRICE](state, data) {
    state.price = data;
  },
  [types.SET_DATE_INIT](state, data) {
    state.date_init = data;
  },
  [types.SET_PRICE_DIP](state, data) {
    state.price_dip = data;
  },
};

export default {
  namespaced: true,
  state,
  actions,
  mutations,
};
